import React from 'react';
import './LegalNotice.scss';
import { CbmModal } from '@groupelacentrale/contact-storybook';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export const LegalNotice: React.FC<Props> = ({ isOpen, onClose }) => {
  return (
    <CbmModal isOpen={isOpen} title="Informations légales" onClose={onClose} size="medium">
      <div className="legal-notice">
        <p>
          <b>
            Afin de renforcer la sécurité des transactions des véhicules d’occasions et de faciliter le dépôt de votre
            annonce
          </b>
          , La Centrale ® et son partenaire, un gestionnaire habilité par les pouvoirs publics à gérer les cartes
          grises, proposent un service gratuit permettant l’accès et la consultation des données techniques de votre
          véhicule figurant sur votre carte grise (conformément à l’article L330-5 du Code de la Route) ainsi que la
          saisie automatique du descriptif de votre véhicule.
        </p>

        <p>
          En choisissant d&apos;accéder à ce service, vous certifiez sur l&apos;honneur être le titulaire de la carte
          grise ou son ayant-droit et donnez mandat à La Centrale et son partenaire Autoviza®, en votre nom et pour
          votre compte, de demander à des tiers, d&apos;accéder, de consulter et de télécharger toutes données
          techniques et administratives relatives à votre véhicule (comme par exemple : marque, modèle, date de mise en
          circulation, puissance fiscale, résultats de contrôles techniques, résultats d’expertises provenant d’experts
          en automobiles auprès d’assureurs, kilométrages, opérations de maintenance et réparations, accidents, et
          toutes autres informations utiles à la transparence d’une transaction de vente de véhicule), ainsi que de
          constituer et d&apos;afficher sur La Centrale ® un rapport historique Autoviza® de votre véhicule. Vous
          autorisez également la réalisation à partir de ces données de statistiques anonymes, ainsi que leur diffusion.
        </p>

        <p>
          Ces données sont destinées à La Centrale ® pour vous permettre de bénéficier de la saisie automatique de ces
          données dans votre annonce en vue de leur publication sur le site internet de La Centrale ®.
        </p>

        <p>
          Dans ce cadre,{' '}
          <b>
            La Centrale ® s&apos;engage à ne pas transmettre les données suivantes vous concernant : nom, prénom,
            adresse, téléphones, email et date de naissance.
          </b>
        </p>

        <p>
          Pour bénéficier du service, il vous suffit de saisir votre numéro d’immatriculation et les 3 derniers chiffres
          du numéro de série de votre véhicule. Après le téléchargement des données techniques du véhicule, vous devez
          compléter les champs obligatoires manquants notamment le kilométrage, les options et le prix du véhicule...
          Ces informations techniques (en aucun cas : vos nom, prénom, adresse, téléphone, email ou date de naissance)
          feront l’objet d’une transmission au gestionnaire habilité et à ses partenaires contractuels lorsque vous
          aurez validé votre annonce.
        </p>

        <p>
          Vous reconnaissez que La Centrale ® et son partenaire Autoviza® n&apos;agissent qu&apos;en qualité de
          mandataires pour obtenir communication des données enregistrées ou compilées par des tiers se rapportant à
          votre véhicule. A ce titre, dans le cadre des opérations requises pour la production du rapport historique
          Autoviza®, Autoviza® n&apos;exerce aucun contrôle sur les données et notamment sur leur contenu, leur véracité
          ou leur exactitude. En conséquence, vous acceptez, que vous demandiez ou que vous refusiez la mise à
          disposition du rapport historique Autoviza® aux acquéreurs potentiels de votre véhicule, que la responsabilité
          de La Centrale ® et de son partenaire Autoviza® ne pourra en aucun cas être retenue, de quelque manière que ce
          soit et à quelque titre que ce soit, pour tout dommage direct et/ou indirect.
        </p>
      </div>
    </CbmModal>
  );
};
